// Helpers condivisi per la pagina Lotti

// Formatta nome operatore: "Cristian Rossi" → "C. Rossi"
export const formatNomeOperatore = (user) => {
  const nome = user?.nome || user?.email || user?.telefono || "";
  if (!nome) return "";
  const parts = nome.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0][0].toUpperCase()}. ${parts.slice(1).join(" ")}`;
  }
  return nome;
};

// Opzioni durata scadenza prodotto aperto
export const DURATE_SCADENZA_APERTO = [
  { value: "3", label: "3 giorni" },
  { value: "5", label: "5 giorni" },
  { value: "7", label: "1 settimana" },
  { value: "10", label: "10 giorni" },
  { value: "15", label: "15 giorni" },
  { value: "30", label: "1 mese" },
  { value: "custom", label: "Altro..." },
];

// Formatta data in italiano (YYYY-MM-DD → DD/MM/YYYY)
export const formatDateIT = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  return `${day}/${month}/${year}`;
};

// Formatta ora corrente in HH:MM
export const formatOraCorrente = () => {
  const now = new Date();
  return `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;
};

// Calcola data scadenza prodotto aperto
export const calcolaDataScadenzaAperto = (dataApertura, giorni) => {
  if (!dataApertura || !giorni) return "";
  const data = new Date(dataApertura);
  data.setDate(data.getDate() + parseInt(giorni, 10));
  return data.toISOString().split("T")[0];
};
